import type {ReactElement} from 'react';
import React from 'react';
import {CustomItemControlsWrapper} from '@Components/poster-editor/components/custom-item-controls/components/custom-item-controls-wrapper/custom-item-controls-wrapper';
import {isEditorMobileVariant} from '@Components/poster-editor/library/poster-editor-library';
import {CustomItemControlsWrapperMobile} from '@Components/poster-editor/components/custom-item-controls/components/custom-item-controls-wrapper-mobile/custom-item-controls-wrapper-mobile';

export function CustomItemControls(): ReactElement<any> | null {
  if (window.posterEditor?.whiteboard?.mode.isWebpage() || window.posterEditor?.whiteboard?.mode.isGeneration()) {
    return null;
  }

  const getCustomItemControls = () => {
    const pages = window.posterEditor?.whiteboard?.pages?.pagesHashMap;
    if (!pages) {
      return null;
    }

    return (
      <>
        {Object.values(pages).map((pageObject) => {
          if (isEditorMobileVariant()) {
            return <CustomItemControlsWrapperMobile key={pageObject.hashedID} pageHashedId={pageObject.hashedID} />;
          } else {
            return <CustomItemControlsWrapper key={pageObject.hashedID} pageHashedId={pageObject.hashedID} />;
          }
        })}
      </>
    );
  };

  return getCustomItemControls();
}
